export const threeYearPlanTimeRange: [number, number] = [new Date().getFullYear(), new Date().getFullYear() + 4];
